import { createReducer } from '@reduxjs/toolkit'
import store from 'store'

import {
  getCountries,
  getAvailableCountries,
  getWorldTimezones,
  getWorldLanguages,
} from './info.action'

const initialState = {
  countries: store.get('countries') || [],
  availableCountries: store.get('available_countries') || [],
  worldLanguages: store.get('languages') || [],
  worldTimezones: store.get('timezones') || [],
  isLoading: false,
  error: null,
}

const infoReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getCountries.fulfilled, (state, action) => {
      console.log('Countries data loaded:', action.payload?.length || 0, 'items')
      store.set('countries', action.payload || [])
      state.countries = action.payload || []
      state.isLoading = false
    })
    .addCase(getAvailableCountries.fulfilled, (state, action) => {
      console.log('Available countries data loaded:', action.payload?.length || 0, 'items')
      store.set('available_countries', action.payload || [])
      state.availableCountries = action.payload || []
      state.isLoading = false
    })
    .addCase(getWorldTimezones.fulfilled, (state, action) => {
      console.log('Timezones data loaded:', action.payload?.length || 0, 'items')
      store.set('timezones', action.payload || [])
      state.worldTimezones = action.payload || []
      state.isLoading = false
    })
    .addCase(getWorldLanguages.fulfilled, (state, action) => {
      console.log('Languages data loaded:', action.payload?.length || 0, 'items')
      store.set('languages', action.payload || [])
      state.worldLanguages = action.payload || []
      state.isLoading = false
    })

    .addMatcher(
      (action) => action.type.endsWith('/pending') && action.type.includes('/info/'),
      (state) => {
        state.isLoading = true
        state.error = null
      }
    )

    .addMatcher(
      (action) => action.type.endsWith('/rejected') && action.type.includes('/info/'),
      (state, action) => {
        state.isLoading = false
        state.error = action.error
        console.error('Info API error:', action.error)
      }
    )

    .addDefaultCase((state) => state)
})

export default infoReducer
